import _ from 'lodash';
import { AdminRole } from './admin-role';
import { AdminPanel } from './admin-panel';

export class AdminOrganization {
  UserPoolId: string;
  OrganizationId: string;
  ClientId: string;
  OrganizationName: string;
  Facilities: any[];
  Applications: any[];
  Panels: any[];
  FacilityPanelMap: any[];

  initialize(data) {
    // Applications
    this.Applications = [];
    _.forEach(data.Applications, app => {
      if(!_.startsWith(_.toLower(app.GroupName), 'analyze')){
        this.Applications.push(Object.assign(new AdminRole(), app));
      }
    });
    this.Applications = _.sortBy(this.Applications, 'Description');

    // Panels
    this.Panels = [];
    _.forEach(data.Panels, panel => {
      if(!_.startsWith(_.toLower(panel.GroupName), 'analyze')){
        panel.Description = "Notify - "+panel.Description;
        this.Panels.push(Object.assign(new AdminPanel(), panel));
      }
    });
    this.Panels = _.sortBy(this.Panels, 'Description');
  }

  getPanelMap(facilityCode: string) {
    return this.FacilityPanelMap[facilityCode];
  }
}
